<template>
  <div class="box m-max-height">
    <ul class="tree">
      <li v-for="(item, index) of items" :key="index" class="item" data-test="slide-item">
        <span @click="toggle(item.title, false)" v-show="getToggle(item.title) && hasValues(item)">
          <icon name="minus" class="toggle-icon" />
        </span>
        <span @click="toggle(item.title, true)" v-show="!getToggle(item.title)">
          <icon name="plus" class="toggle-icon" />
        </span>
        <icon name="plus" class="toggle-icon" v-show="!hasValues(item)" style="color: #ccc" />
        {{ item.title }}
        <ul v-show="getToggle(item.title)" class="tree-sub">
          <li v-for="subItem of item.values" :key="subItem.title" class="sub-item" style="flex-direction: column">
            <div data-test="slide-itemSub" style="display: flex;">              
              <div v-html=subItem.title />
              <div>
                <span @click="theDelete(subItem)" v-show="canDelete && !subItem.noDelete">
                <icon name="times" class="times-icon" />
              </span>
              </div>              
            </div>
            <ul v-if="subItem.items && subItem.items.length > 0" class="tree-sub" style="width: 100%">
              <li class="sub-item" v-for="subSubItem of subItem.items" :key="subSubItem">{{ subSubItem }}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
// import _ from 'lodash'

export default {
  components: {
  },
  props: {
    canDelete: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    deleteFun: {
      type: Function,
      defualt(item) { }
    }
  },
  data() {
    return {
      toggleDict: {}
    }
  },
  computed: {
  },
  methods: {
    toggle(key, stauts) {
      this.$set(this.toggleDict, key, stauts)
    },
    getToggle(key) {
      if (this.toggleDict.hasOwnProperty(key)) {
        return this.toggleDict[key]
      } else {
        return true
      }
    },
    hasValues(item) {
      if (item.values === undefined) {
        return false
      } else {
        return item.values.length > 0
      }
    },
    theDelete(item) {
      this.deleteFun(item)
    }
  }
}
</script>
<style scoped lang="scss">
ul.tree li {
  list-style: none;
  position: relative;
}



ul.tree li:before {
  position: absolute;
  content: '';
  top: -2px;
  left: -0.7em;
  width: 0.5em;
  height: 70%;
  border-style: none none solid solid;
  border-width: 0.05em;
  border-color: #aaa;
}

ul.tree>li:before {
  border-style: none none none none;
  content: '';
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border: 0;
}

ul.tree li:not(:last-child):after {
  position: absolute;
  content: '';
  top: 0.7em;
  left: -0.7em;
  bottom: 0;
  border-style: none none none solid;
  border-width: 1px;
  border-color: #aaa;
}

ul.tree>li:after {
  border-style: none none none none;
  content: '';
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border: 0;
}

.title {
  margin-top: 8px;
}

.tree {
  padding: 0;
}

.tree-sub {
  padding-left: 16px;
}

.item {
  margin-top: 8px;
  color: $color-grey3;
}

.sub-item {
  padding: 0;
  padding-top: 8px;
  color: $color-grey3;
}

.times-icon {
  margin-left: 4px;
  vertical-align: middle;
  color: $color-grey3;
  cursor: pointer;
}

.toggle-icon {
  color: $color-primary;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/slide/MSlideItem.vue